import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "step-body"
}
const _hoisted_2 = { class: "body-content" }
const _hoisted_3 = { class: "form-group values-group" }
const _hoisted_4 = { class: "value-display" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "value-display" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "value-display" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "form-group requested-amount" }
const _hoisted_11 = {
  key: 2,
  class: "step-btns"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_base_form_field = _resolveComponent("base-form-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          inverse: true
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "step-title" }, "Amount Requested", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "step-desc" }, "Input the amount you would like to borrow.", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Total Line Amount:", -1)),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.loanAmount), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("label", null, "Available to Borrow:", -1)),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.availableToBorrow), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("label", null, "Last Requested Draw:", -1)),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.lastRequestedDraw), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "requestedAmount" }, "Requested Amount", -1)),
              _createVNode(_component_base_form_field, {
                schema: _ctx.schema.amount,
                modelValue: _ctx.requestedAmount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestedAmount) = $event)),
                compare: { availableToBorrow: _ctx.Loan?.availableToBorrow, minimum: _ctx.minimum, minimumDisplay: _ctx.minimumDisplay }
              }, null, 8, ["schema", "modelValue", "compare"])
            ])
          ])
        ])),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            disabled: _ctx.loading,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('goback')), ["prevent"]))
          }, " Go Back ", 8, _hoisted_12),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm cuscd-button-color-cta",
            disabled: _ctx.loading || _ctx.requestedAmount === '' || !_ctx.validRequestedAmount,
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.completeRequestAmount && _ctx.completeRequestAmount(...args)), ["prevent"]))
          }, " Review Request ", 8, _hoisted_13)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}